<template>
  <div class="profile">
    <Header :showService="false" />

    <div class="main">
      <Content :userData="toSendUser" />
    </div>

    <Footer />
  </div>
</template>

<script>
import { mapState } from "vuex";
import Footer from "../../components/layout/Footer.vue";
import Header from "../../components/private/Header";
import Content from "./components/Content.vue";
import { formatRole } from "../../components/tools/utils";
import axios from "axios";

export default {
  components: {
    Header,
    Content,
    Footer,
  },
  data() {
    return {
      toSendUser: null,
    };
  },
  computed: {
    ...mapState("sesion", ["usuario"]),
  },
  methods: {
    requestUserData: async function() {
      if (this.usuario.username === process.env.VUE_APP_USER_ADMIN) {
        this.toSendUser = {
          perfil: "SuperAdministrador",
          perfilId: 1,
          servicioId: this.$route.params.idServicio,
        };

        return;
      }
      try {
        console.log(this.usuario);
        const usuario = await axios.get(
          `${process.env.VUE_APP_RUTA_API}/usuarios/usuarios/${this.usuario.id}/`,
          {
            headers: {
              Authorization: `JWT ${localStorage.getItem("userToken")}`,
            },
          }
        );

        const isUserService = usuario.data.servicios.find(
          (s) => s.id === parseInt(this.$route.params.idServicio)
        );

        console.log(isUserService);

        if (isUserService) {
          this.toSendUser = {
            perfil: formatRole(isUserService.rolNombre),
            perfilId: isUserService.rolId,
            servicioNombre: isUserService.nombre,
            servicioMinis: isUserService.ministerio,
            servicioId: this.$route.params.idServicio,
            permisos: isUserService.permisos,
          };
        }
      } catch (error) {
        console.log(error.response);
      }
    },
  },
  mounted() {
    this.requestUserData();
    this.$store.commit("setPrivateView", "escritorio-virtual");
  },
};
</script>

<style scoped>
.main {
  background: #fff;
}
</style>
